module.exports = __webpack_public_path__ + "img/show_img1.4c599472.png";